import { render, staticRenderFns } from "./ImsMultiselect.vue?vue&type=template&id=bc89eca2"
import script from "./ImsMultiselect.vue?vue&type=script&lang=js"
export * from "./ImsMultiselect.vue?vue&type=script&lang=js"
import style0 from "./ImsMultiselect.vue?vue&type=style&index=0&id=bc89eca2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports